import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[site]/site/[lang]/layout-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/fallback-error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/node_modules/.pnpm/react-error-boundary@4.1.0_react@18.3.1/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
